import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const TooltipLable = ({ text, tooltip, placement = "right" }) => {
  const bg = "#f1f8ff"
  const border = "#b6d4fe"
  const color = "#084298"

   
  return (
    <span className="d-inline-flex align-items-center gap-1">
      <OverlayTrigger
        placement={placement}
        overlay={
          <Tooltip
            style={{
              "--bs-tooltip-bg": bg,
              "--bs-tooltip-color": color,
              border: `1px solid ${border}`,
              boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              maxWidth: "280px",
              borderRadius:"8px"
            }}
          >
            {tooltip}
          </Tooltip>
        }
      >
        <span style={{ cursor: "pointer" }}>{text}</span>
      </OverlayTrigger>
    </span>
  )
}

export default TooltipLable